// DS: i5.2
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Comment: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        width="0"
        height="0"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          d="M20 3H6.414a1 1 0 0 0-.707.293L3.293 5.707A1 1 0 0 0 3 6.414V16a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h1.5a1 1 0 0 0 .8-.4L13 17h4.586a1 1 0 0 0 .707-.293l2.414-2.414a1 1 0 0 0 .293-.707V4a1 1 0 0 0-1-1"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
Comment.displayName = 'Comment';

export default Comment;
